import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "head_container"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
    src: $props.headIcon,
    alt: ""
  }, null, 8, _hoisted_2), _createElementVNode("span", _hoisted_3, _toDisplayString($props.title), 1), _createElementVNode("div", null, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])]);
}